function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_228",
  "data-name": "Group 228",
  transform: "translate(0 -1)"
}, React.createElement("path", {
  id: "Path_247",
  "data-name": "Path 247",
  d: "M1.9,24A2.014,2.014,0,0,0,4,22.1V10.5A1.9,1.9,0,0,0,1.9,8.6,1.967,1.967,0,0,0,0,10.5V22A1.988,1.988,0,0,0,1.9,24Z",
  fill: "#606060"
}), React.createElement("g", {
  id: "Group_223",
  "data-name": "Group 223"
}, React.createElement("path", {
  id: "Path_248",
  "data-name": "Path 248",
  d: "M23,12.149a2.014,2.014,0,0,0-1.9-2.1H9.9a1.9,1.9,0,0,0-1.9,2.1,1.967,1.967,0,0,0,1.9,1.9H21A1.988,1.988,0,0,0,23,12.149Z",
  fill: "#606060"
}), React.createElement("path", {
  id: "Path_249",
  "data-name": "Path 249",
  d: "M23,19.649a2.014,2.014,0,0,0-1.9-2.1H9.9a1.9,1.9,0,0,0-1.9,2.1,1.967,1.967,0,0,0,1.9,1.9H21A1.988,1.988,0,0,0,23,19.649Z",
  fill: "#606060"
})), React.createElement("path", {
  id: "Path_250",
  "data-name": "Path 250",
  d: "M23,2.1A2.014,2.014,0,0,0,21.1,0H1.9A1.951,1.951,0,0,0,0,2.1,1.967,1.967,0,0,0,1.9,4H21A1.988,1.988,0,0,0,23,2.1Z",
  transform: "translate(0 1)",
  fill: "#606060"
}));

var SvgReference = function SvgReference(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReference, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reference.ac3c76fa.svg";
export { ForwardRef as ReactComponent };